import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState, AppDispatch } from '../index'
import {
  openKlineModal,
  closeKlineModal,
  updateTradingPair,
  setCurrentTradingPair,
  clearTradingPair,
  TradingPair
} from './actions'
import { KlineState } from './reducer'

// 获取K线图状态
export function useKlineState(): KlineState {
  return useSelector<AppState, KlineState>(state => state.kline)
}

// 获取K线图弹窗开关状态
export function useKlineModalOpen(): boolean {
  return useSelector<AppState, boolean>(state => state.kline.isModalOpen)
}

// 获取当前交易对信息
export function useCurrentTradingPair(): TradingPair | null {
  return useSelector<AppState, TradingPair | null>(state => state.kline.currentTradingPair)
}

// K线图操作hooks
export function useKlineActions() {
  const dispatch = useDispatch<AppDispatch>()

  const openModal = useCallback(() => {
    dispatch(openKlineModal())
  }, [dispatch])

  const closeModal = useCallback(() => {
    dispatch(closeKlineModal())
  }, [dispatch])

  const updatePair = useCallback(
    (tradingPair: TradingPair) => {
      dispatch(updateTradingPair(tradingPair))
    },
    [dispatch]
  )

  const setCurrentPair = useCallback(
    (tradingPair: TradingPair) => {
      dispatch(setCurrentTradingPair(tradingPair))
    },
    [dispatch]
  )

  const clearPair = useCallback(() => {
    dispatch(clearTradingPair())
  }, [dispatch])

  return {
    openModal,
    closeModal,
    updatePair,
    setCurrentPair,
    clearPair
  }
}

// 组合hook，提供完整的K线图状态和操作
export function useKline() {
  const state = useKlineState()
  const actions = useKlineActions()

  return {
    ...state,
    ...actions
  }
}